import { css } from 'styled-components';
import { ISPaymentOptionCardProps } from './models';

export const PaymentOptionCard = ({ theme, breakingSizeQuery }: ISPaymentOptionCardProps) => {
  return css`
    text-align: center;

    h1 {
      font-family: Poppins;
      font-style: normal;
      font-weight: bold;
      font-size: 56px;
      line-height: 46px;
    }

    h3 {
      font-family: Poppins;
      font-style: normal;
      font-weight: bold;
      font-size: 21px;
      line-height: 25px;
    }

    .amount-txt {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      font-size: 12px;

      > strong {
        font-size: 14px;
      }
    }

    .selected .amount-txt {
      color: white;
    }

    @media only screen and ${breakingSizeQuery || '(min-width: 1320px)'} {
      h1 {
        font-size: 40px;
        line-height: 40px;
      }

      h3 {
        line-height: 31px;
      }
    }
  `;
};
